import {mixins} from "../app/mixin";

mixins.push({
    el: '.faqSection',
    data() {
        return {
            selectedFAQ: -1, heights: [],
        }
    }, methods: {
        makeActive(index) {
            if (index === this.selectedFAQ) {
                this.selectedFAQ = -1;
            } else {
                const el = document.getElementsByClassName('accordion__value')[index]
                // el.style.maxHeight(el.scrollHeight);
                this.heights[index] = el.scrollHeight;

                this.selectedFAQ = index;
            }
        },
    }, mounted() {
        const faqEls = document.getElementsByClassName('accordion__value');

        for (const faqEl of faqEls) {
            this.heights.push(faqEl.scrollHeight);
        }
    },
});